/**
 * Detects and ignores XMLHttpRequest to Russian domains
 *
 * @param {object} report The report object
 * @returns {boolean} Returns true if the report matches
 */
function xhrNetworkError(report) {
  if (
    report.errorMessage.search(/http(s)?:\/\/[\d-.A-z]+\.ru(\/\S*)?/g) !== -1 &&
    report.errorMessage.includes("XMLHttpRequest")
  ) {
    report.ignore();

    return true;
  }

  return false;
}

export default xhrNetworkError;
